'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _constants = require('./constants');

function getTrackHandler(Tracker) {
  return function (_ref) {
    var eventKey = _ref.eventKey,
        eventProperties = _ref.eventProperties;

    Tracker.track(eventKey, eventProperties);
  };
}

exports.default = function (Tracker) {
  var handlers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var track = getTrackHandler(Tracker);
  return function (store) {
    return function (next) {
      return function (action) {
        var prevState = store.getState();
        var result = next(action);
        var explicitEventSpec = action.meta && action.meta[_constants.TRACK_EVENT];
        var handler = handlers[action.type];

        if (explicitEventSpec) {
          track(explicitEventSpec);
        } else if (typeof handler === 'function') {
          handler(action, store.getState(), store.dispatch, prevState);
        } else if ((typeof handler === 'undefined' ? 'undefined' : _typeof(handler)) === 'object') {
          track(handler);
        }

        return result;
      };
    };
  };
};

module.exports = exports['default'];